var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"login"},nativeOn:{"click":function($event){return _vm.logout.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('navbar.items.logout')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }